import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'linking-tree',
  templateUrl: './linking-tree.component.html',
  styleUrls: ['./linking-tree.component.scss']
})
export class LinkingTreeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
